import React from "react";
import Select, { SelectProps } from "@/components/atoms/Select";
import { CreateOrderDropdownValue } from "@/types";
import { useAuth } from "@/contexts/AuthContext";
import { useGetAllSalesItemsByLanguageId } from "@/services/Product";

type keyOptions = Extract<keyof CreateOrderDropdownValue, string>;

interface SelectPropsExtended extends SelectProps {
  valueKey: keyOptions;
  labelKey: keyOptions | keyOptions[];
}

/**
 * SelectCondition component renders a Select dropdown for conditions.
 * - If `materialId` and `conditionId` is provided, it fetches and displays valid conditions for that material.
 * - If `materialId` and `conditionId` is not provided, it displays all available conditions.
 * - Uses translation for option labels.
 *
 * @param {SelectPropsExtended} props - Props for the SelectCondition component.
 * @param {keyOptions} props.valueKey - Key to use for option values.
 * @param {keyOptions} props.labelKey - Key to use for option labels.
 */
const SelectProductType: React.FC<SelectPropsExtended> = ({
  valueKey,
  labelKey,
  ...restProps
}: SelectPropsExtended) => {
  const { user } = useAuth();
  const { data: salesItemsData, isLoading } = useGetAllSalesItemsByLanguageId(user?.language.id as number, {
    enabled: !!user?.language.id,
  });

  return (
    <Select
      data-testid={"select-product-material-select"}
      data={salesItemsData?.map((item) => ({
        value: item.salesItemId.toString(),
        label: item.salesItemTranslated,
      }))}
      loading={isLoading}
      {...restProps}
    />
  );
};
export default SelectProductType;
